import { Getters, Mutations, Actions, Module, createMapper } from 'vuex-smart-module';
const namespaced = true;
class UiState {
    constructor() {
        this.currentDevice = null;
        this.menuIsOpen = false;
        this.breakpoint = null;
        this.formCallIsShown = false;
        this.formPayIsShown = false;
        this.windowWidth = null;
    }
}
class UiGetters extends Getters {
    get isMobile() { return this.state.currentDevice.type === 'mobile'; }
    get isTablet() { return this.state.currentDevice.type === 'tablet'; }
    get isDesktop() { return this.state.currentDevice.type === 'desktop'; }
    get isTouchDevice() { return this.state.currentDevice.type !== 'desktop'; }
}
class UiMutations extends Mutations {
    setCurrentDevice(payload) {
        const { orientation, type, os } = payload;
        this.state.currentDevice = Object.assign({}, { orientation, type, os });
    }
    toggleMenu() { this.state.menuIsOpen = !this.state.menuIsOpen; }
    openMenu() { this.state.menuIsOpen = true; }
    closeMenu() { this.state.menuIsOpen = false; }
    setWindowWidth(width) { this.state.windowWidth = width; }
    setBreakpoint(payload) { this.state.breakpoint = payload; }
    openFormCall() {
        this.state.formCallIsShown = true;
        document.body.classList.add('modal-open');
    }
    closeFormCall() {
        this.state.formCallIsShown = false;
        document.body.classList.remove('modal-open');
    }
    openFormPay() {
        this.state.formPayIsShown = true;
        document.body.classList.add('modal-open');
    }
    closeFormPay() {
        this.state.formPayIsShown = false;
        document.body.classList.remove('modal-open');
    }
}
class UiActions extends Actions {
}
export const UiStore = new Module({
    namespaced,
    state: UiState,
    getters: UiGetters,
    mutations: UiMutations,
    actions: UiActions,
});
export const uiMapper = createMapper(UiStore);
